import { Button as ButtonBase, ButtonProps } from 'antd';

export const Button: React.FC<ButtonProps> = ({ className, ...props }) => {
  return <ButtonBase className={className} {...props} />;
};
